import { Component, OnInit } from '@angular/core';
import { Video } from 'src/app/models/video';
import { VideoService } from 'src/app/service/video.service';

@Component({
  selector: 'app-detalle-video',
  templateUrl: './detalle-video.component.html',
  styleUrls: ['./detalle-video.component.css']
})
export class DetalleVideoComponent implements OnInit {
  video: Video;

  constructor(private videoservice: VideoService) {
    this.video = videoservice.video;
   }

  ngOnInit() {
    // ocultar grafica Grabacion
    const valorGrabacion = this.videoservice.video.porcentajeGrabacion;
    if (valorGrabacion === '0' || valorGrabacion === '') {

    document.querySelector('#grabacion').parentElement.parentElement.style.display = 'none';
    }
    // ocultar grafica Premiere
    const valorPremiere = this.videoservice.video.porcentajePremiere;
    if (valorPremiere === '0' || valorPremiere === '') {

      document.querySelector('#premiere').parentElement.parentElement.style.display = 'none';
    }
    // ocultar grafica Final Cut
    const valorFinalcut = this.videoservice.video.porcentajeFinalCut;
    if (valorFinalcut === '0' || valorFinalcut === '') {

      document.querySelector('#finalcut').parentElement.parentElement.style.display = 'none';
    }

    // ocultar grafica Posproduccion
    const valorPosproduccion = this.videoservice.video.porcentajePosproduccion;
    if (valorPosproduccion === '0' || valorPosproduccion === '') {

      document.querySelector('#posproduccion').parentElement.parentElement.style.display = 'none';
    }
  }


}
